<template>
  <nav class="navbar p-0 navbar-light fixed-top">
    <div class="justify-content-between flex-nowrap flex-row">
      <div class="user-name-area-wrap container-fuild w-100 text-danger">
      <div class="user-name-area navbar-brand text-danger w-75">
        <trans-text i18nKey="ui[93][1]" :replaceData="{user_name:userName}" :isHtml="true"/>
      </div>
        <!--<router-link :to="{ name: 'top', params: {} }" class="navbar-brand">-->
          <!--<img src="~assets/photo_spot_international_header_logo.png" class="img-fluid">-->
        <!--</router-link>-->

        <header-right-menu-mobile @logout="logout" iconSizeClass="fa-3x" headerHeight="50" />
      </div>
    </div>
    <div class="row nav-cell-area no-gutters">
      <div class="col">
          <router-link tag="div" class="nav-cell w-100 h-100" :to="{ name: 'mypage::event'}">
            <i class="fa fa-clone" aria-hidden="true"></i>
          </router-link>
      </div>
      <div class="col">
        <router-link tag="div" class="nav-cell w-100 h-100 d-inline-block" :to="{ name: 'mypage::orderer_info'}">
          <i class="fa fa-address-book" aria-hidden="true"></i>
        </router-link>
      </div>
      <div class="col">
        <router-link tag="div" class="nav-cell w-100 h-100 d-inline-block" :to="{ name: 'mypage::child_info'}">
          <i class="fa fa-child" aria-hidden="true"></i>
        </router-link>
      </div>
      <div class="col">
        <router-link tag="div" class="nav-cell w-100 h-100 d-inline-block" :to="{ name: 'mypage::order'}">
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import HeaderRightMenuMobile from 'components/global/partials/HeaderRightMenuMobile.vue'

  export default {
    name:"",
    components: {
      HeaderRightMenuMobile,
    },
    data () {
      return {
      }
    },
    computed:{
      userName(){
        let user = store.get("user")
        return `${user.family_name} ${user.given_name}`
      }
    },
    mounted(){
      this.$nextTick(()=>{
        app.make("adjustLayout")()
      })
    },
    methods:{
      logout(){
        this.$emit('logout')
      }
    }
  }
</script>


<style lang="scss" scoped>

  .navbar {
    background-size: 10% auto;
    background-color: #fcd599;
    .user-name-area-wrap{
      position: relative;
      &:before{
        content: '\f2bd';
        font-size: 1.8rem;
        font-family: FontAwesome;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(50%);
        left: 0;
      }
    }
    .navbar-brand {
      white-space:normal !important;
      word-wrap:break-word;

      width: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      font-weight: bold;
      &.user-name-area{

      }
    }
  .nav-cell-area{
    border-bottom: 3px solid #7dbe12;
    .nav-cell{
      padding:.3rem .5rem .2rem .5rem;
      width: 100%;
      text-align: center;
      background-color: #ffffff;
      border-right: 1px solid #7dbe12;
      cursor: pointer;
      &.router-link-active {
        background-color: rgba(225, 245, 209, 1);
        position: relative;

        &:before{
          font-family: FontAwesome;
          content: '\F0D7';
          position: absolute;
          bottom: -78%;
          left: 50%;
          transform: translateY(0) translateX(-50%);
          color: #72b003;
          font-size: 1.8rem;
        }
      }

      i{
        font-size: 1.5rem;
//        font-weight: bold;
        color: #7dbe12;
      }
    }
    .col:last-child{
      .nav-cell{
        border-right:none;
      }

    }

  }

  }
</style>



// WEBPACK FOOTER //
// MobileHeader.vue?10afe867